import { getGetApiEmbeddingCollectionGetQueryKey, useGetApiEmbeddingCollectionGet, usePostApiEmbeddingAddText } from "@/API";
import { Button, Group, Modal, TagsInput, Textarea, TextInput } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, useState } from "react";
import { z } from "zod";
// import { zodResolver } from 'mantine-form-zod-resolver';

export function EmbeddingAddTextButton(props: { workspaceId: string, collectionId: string, tagsOptions: string[] } & PropsWithChildren) {
    const queryClient = useQueryClient()
    const [opened, { open, close }] = useDisclosure(false);
    const addText_Mutation = usePostApiEmbeddingAddText({
        axios: {
            headers: { "Content-Type": "application/json" }
        }
    })
    const [loading, setLoading] = useState(false)
    return <>
        <div onClick={() => open()}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} closeOnClickOutside={false} closeOnEscape={!loading} withCloseButton={!loading} title="新增內容集合" >
            <EmbeddingAddTextForm tagsOptions={props.tagsOptions} loading={loading} onSubmit={async d => {
                setLoading(true)
                try {
                    await addText_Mutation.mutateAsync({
                        params: {
                            workspaceId: props.workspaceId,
                            collectionId: props.collectionId
                        },
                        data: {
                            texts: [{
                                text: d.text,
                                template: d.template
                            }],
                            description: d.description,
                            tags: d.tags
                        }
                    })
                    queryClient.invalidateQueries({ queryKey: getGetApiEmbeddingCollectionGetQueryKey({ id: props.collectionId }) })
                    close()
                    notifications.show({ message: "新增成功" })
                }
                catch (e) {
                    notifications.show({ message: "新增失敗", color: "red" })
                }
                setLoading(false)
            }} />
        </Modal>
    </>
}

export interface EmbeddingAddTextFormData {
    text: string,
    template?: string,
    description: string
    tags: string[]
}
export function EmbeddingAddTextForm(props: { tagsOptions: string[], loading?: boolean, onSubmit: (data: EmbeddingAddTextFormData) => void }) {
    const schema = z.object({
        text: z.union([
            z.string().min(3, { message: '至少要3個字' }),
            z.literal(''),
        ]),
    });
    const form = useForm<EmbeddingAddTextFormData>({
        mode: 'uncontrolled',
        initialValues: {
            text: '',
            description: '',
            tags: []
        },
        validate: schemaResolver(schema)
    });
    return <>
        <form onSubmit={form.onSubmit((values) => {
            props.onSubmit(values)
        })}>
            <TextInput
                label="簡述"
                placeholder="optional"
                {...form.getInputProps('description')}
            />
            <TagsInput label="資料標籤" placeholder="optional"
                data={props.tagsOptions}
                {...form.getInputProps('tags')}
            />
            <Textarea
                label="初始內容"
                placeholder="optional"
                rows={8}
                {...form.getInputProps('text')}
            />
            <Textarea
                label="初始Template"
                description="可以使用{{$text}}引用Text"
                placeholder="optional"
                rows={1}
                maxRows={5}
                autosize
                {...form.getInputProps('template')}
            />
            <Group justify="flex-end" mt="md">
                <Button type="submit" loading={props.loading}>新增</Button>
            </Group>
        </form>
    </>
}